import { render, staticRenderFns } from "./Crypto.vue?vue&type=template&id=12c896d5&"
import script from "./Crypto.vue?vue&type=script&lang=js&"
export * from "./Crypto.vue?vue&type=script&lang=js&"
import style0 from "./Crypto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports